<template>
  <div>
    <el-form
      :model="formParams"
      class="elFormClass"
      ref="ruleForm"
      label-width="auto"
      size="small"
    >
      <el-form-item label="旧密码" :rules="formRules.requiredChange">
        <el-input v-model="formParams['oldPwd']"></el-input>
      </el-form-item>
      <el-form-item label="新密码" :rules="formRules.requiredChange">
        <el-input type="password"               show-password
 v-model="formParams['pwd']"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog_bottom">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
import { getRsaPwd } from "@/utils/rsaPassword";
export default {
  data() {
    return {
      formParams: {},
    };
  },
  mounted() {},
  methods: {
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 获取rsa key
          this.$requestAxios(
            {
              url: "/public/public_key",
              data: {
                deviceCode: localStorage.getItem("deviceCode"),
              },
            },
            (data) => {
              let newform = Object.assign(
                {
                  deviceCode: localStorage.getItem("deviceCode"),
                },
                this.formParams
              );
              newform.pwd = getRsaPwd(
                newform.pwd,
                data.data.modulus,
                data.data.exponent
              );
              this.$requestAxios(
                {
                  data: newform,
                  url: "/pc/admin/edit_pwd",
                },
                () => {
                  this.$success("修改成功,请重新登录!");
                  this.$router.push({
                    name: "login",
                    query: {
                      redirect: "/login",
                    },
                  });
                }
              );
            },
            (err) => {}
          );
        }
      });
    },
  },
};
</script>
<style scoped></style>
